import axios, { AxiosInstance, AxiosResponse } from 'axios';

export interface WhatsappTemplate {
  id: string;
  cnpj: string;
  name: string;
  body: string;
  channel: 'WHATSAPP';
  variables?: string[];
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateWhatsappTemplateRequest {
  name: string;
  body: string;
  active?: boolean;
}

export interface UpdateWhatsappTemplateRequest {
  name?: string;
  body?: string;
  active?: boolean;
}

class WhatsappTemplateService {
  private client: AxiosInstance;

  constructor() {
    this.client = axios.create({
      baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000/api',
      timeout: 10000,
    });

    this.client.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
          config.headers = config.headers || {};
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  }

  async listTemplates(cnpj?: string): Promise<WhatsappTemplate[]> {
    try {
      const response: AxiosResponse<WhatsappTemplate[]> = await this.client.get('/admin/whatsapp-templates', {
        params: cnpj ? { cnpj } : undefined,
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Erro ao listar templates de WhatsApp');
    }
  }

  async createTemplate(data: CreateWhatsappTemplateRequest): Promise<WhatsappTemplate> {
    try {
      const response: AxiosResponse<WhatsappTemplate> = await this.client.post('/admin/whatsapp-templates', data);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Erro ao criar template de WhatsApp');
    }
  }

  async updateTemplate(id: string, data: UpdateWhatsappTemplateRequest): Promise<WhatsappTemplate> {
    try {
      const response: AxiosResponse<WhatsappTemplate> = await this.client.put(`/admin/whatsapp-templates/${id}`, data);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Erro ao atualizar template de WhatsApp');
    }
  }
}

export const whatsappTemplateService = new WhatsappTemplateService();
export default whatsappTemplateService;
